// extracted by mini-css-extract-plugin
module.exports = {"About":"About_About__1bMi-","svgCtn":"About_svgCtn__11wxz","hide":"About_hide__1zrXp"};